import _isEmpty from 'underscore/cjs/isEmpty.js'

import { useUtmsStore } from './utms'

export const useHomeLoansStore = defineStore('home-loans', {
  state: () => ({
    guides: {
      url: null,
      initialPage: ''
    },
    form: {}
  }),

  getters: {
    leadParams () {
      const form = this.form

      if (_isEmpty(form)) {
        return {}
      }

      const utmsStore = useUtmsStore()
      const formData = flattenObj(form, 2)

      const name = getName(formData?.full_name)

      const removeChar = str => +(str && str.replace(/[%$,]/g, '')) || ''

      const application = (() => {
        const isRefinance = +formData?.refinance

        if (isRefinance) {
          return {
            applicant_assets_funds_available: removeChar(formData?.total_income),
            purchase_properties_loan_amount: (parseInt(removeChar(formData?.consolidated_debt_amt)) || 0) + (parseInt(removeChar(formData?.loan_balance)) || 0) + (parseInt(removeChar(formData?.extra_cashout_amt)) || 0),
            current_loan_balance: removeChar(formData?.loan_balance),
            purchase_properties_price: removeChar(formData?.property_value),
            purchase_timeframe: '',
            interest_last_reviewed: formData?.interest_last_reviewed,
            is_extra_cashout: formData?.extra_cashout_required,
            extra_cashout_amt: removeChar(formData?.extra_cashout_amt),
            consolidate_debts: formData?.consolidate_debts,
            consolidated_debt_amt: removeChar(formData?.consolidated_debt_amt)
          }
        }

        const loanAmount = removeChar(formData?.loan_amount)
        const depositAmount = removeChar(formData?.deposit)

        return {
          purchase_properties_price: loanAmount,
          deposit_amount: depositAmount,
          purchase_timeframe: formData?.buying_situation || '',
          purchase_properties_loan_amount: parseInt((loanAmount === depositAmount || depositAmount > loanAmount)
            ? loanAmount * 0.95
            : loanAmount - depositAmount)
        }
      })()

      const obj = {
        ...application,
        finalize_request: '1',
        intending: formData?.intending,
        partner_assets_funds_available: removeChar(formData?.total_other_income) || '',
        pid: 'rate-comparison',
        property_address: '',
        applicant_assets_gross_salary: removeChar(formData?.total_income),
        partner_assets_gross_salary: removeChar(formData?.total_other_income),
        purchase_properties_financing_purpose: formData?.intending,
        purchase_properties_first_home: formData?.first_home,
        purchase_properties_use: formData?.intending,
        loan_applicants: formData?.buying_property,
        // lender_offering: formData?.lender_reason.join('; '),
        reason: '',
        refinance: formData?.refinance,
        current_home_loan_rate: removeChar(formData?.interest_rate),

        // personal
        address: formData?.postcode,
        email: formData?.email,
        firstname: name?.first_name,
        lastname: name?.last_name,
        fullname: name?.name,
        partner_email: '',
        partner_firstname: 'Partner',
        partner_lastname: 'Partner',
        partner_mobile: '',
        partner_postcode: '',
        partner_state: '',
        partner_suburb: '',
        phone: formData?.phone,
        postcode: formData?.postcode,
        state: formData?.state,
        suburb: formData?.suburb,

        // external
        brand: 'CompareClub',
        form_page: import.meta.client && window.location.href,
        source: formData?.source || (import.meta.client && window.location.href),
        website_source: formData?.website_source || utmsStore.utms.website_source || 'CompareClub',
        notes: formData?.notes || '',
        landing_page: utmsStore.GET_UTMS_LANDING_PAGE
      }

      return obj
    }
  },

  actions: {
    async createLead (payload) {
      const utmsStore = useUtmsStore()

      const response = await useFetch('/api/lead/create', {
        method: 'post',
        body: {
          ...utmsStore.utms,
          ...payload,
          vertical: 'Home Loan Form' // this is to lock the api key lookup logic
        }
      }).then(res => {
        const temp = res?.data.value

        if (temp?.error) {
          throw temp?.error
        }

        const data = temp?.data

        setLocal('uuid', data?.lead_uuid)
        setLocal('refinance', payload?.refinance)
        setLocal('purchase_timeframe', payload?.purchase_timeframe)
        setLocal('intending', payload?.intending)
        setLocal('postcode', payload?.postcode)
        setLocal('purchase_properties_financing_purpose', payload?.purchase_properties_financing_purpose || '')
        setLocal('deposit_amount', payload?.deposit_amount || '')
        setLocal('purchase_properties_price', payload?.purchase_properties_price || '')
        setLocal('applicant_assets_gross_salary', payload?.applicant_assets_gross_salary || '')
        setLocal('applicant_assets_funds_available', payload?.applicant_assets_funds_available || '')
        setLocal('current_home_loan_rate', payload?.current_home_loan_rate || '')

        return data?.lead_uuid ?? undefined
      }).catch(error => {
        throw error
      })

      return response
    }
  }
})
